var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "clearfix" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small", "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("optionDatePicker", {
                        on: { changeOptTime: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-search",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-refresh" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "mt14 stats-row" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "stat-card stat-blue" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("累计收款总额"),
                  ]),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v("¥" + _vm._s(_vm.stats.totalAmount || "0.00")),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "stat-card stat-green" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("余额收款"),
                  ]),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v("¥" + _vm._s(_vm.stats.totalBalance || "0.00")),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "stat-card stat-orange" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("积分收款"),
                  ]),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v("¥" + _vm._s(_vm.stats.totalIntegral || "0.00")),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "60" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "收款单号",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "付款用户", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v("UID: " + _vm._s(scope.row.uid))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "消费金额", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v("¥" + _vm._s(scope.row.originalAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "折扣", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.discountRate &&
                        parseFloat(scope.row.discountRate) < 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.discountLabel(scope.row.discountRate)
                                  )
                                ),
                              ]
                            )
                          : _c("span", { staticClass: "text-muted" }, [
                              _vm._v("无折扣"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "实收金额", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _c("p", { staticClass: "amount-total" }, [
                            _vm._v("合计：¥" + _vm._s(scope.row.totalAmount)),
                          ]),
                          parseFloat(scope.row.balanceAmount) > 0
                            ? _c("p", { staticClass: "amount-detail" }, [
                                _vm._v(
                                  " 余额：¥" +
                                    _vm._s(scope.row.balanceAmount) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          parseFloat(scope.row.integralAmount) > 0
                            ? _c("p", { staticClass: "amount-detail" }, [
                                _vm._v(
                                  " 积分：¥" +
                                    _vm._s(scope.row.integralAmount) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.status === 1 ? "success" : "info",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status === 1 ? "已完成" : "处理中"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "收款时间",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }